import React from 'react';
// this high order component will ensure that the Wrapped Component
// will always be unmounted, even if React does not have the time to
// call componentWillUnmount function
export default class WithGracefulUnmount extends React.Component {
    constructor(props) {
        super(props);
        this.state = { mounted: false };
        this.componentGracefulUnmount = this.componentGracefulUnmount.bind(this);
    }

    componentGracefulUnmount() {
        this.setState({ mounted: false });

        window.removeEventListener('pagehide', this.componentGracefulUnmount);
    }

    componentWillMount() {
        this.setState({ mounted: true });
    }

    componentDidMount() {
        // make sure the componentWillUnmount of the wrapped instance is executed even if React
        // does not have the time to unmount properly. we achieve that by
        // * hooking on pagehide, which only fires when the page is actually being torn down
        //   (unlike beforeunload, it never fires just because a beforeunload prompt was shown
        //   and cancelled, so it won't blank the app out from under a user who chooses to stay)
        window.addEventListener('pagehide', this.componentGracefulUnmount);
    }

    componentWillUnmount() {
        this.componentGracefulUnmount();
    }

    render() {
        const { mounted } = this.state;

        if (mounted) {
            return <div>{this.props.children}</div>;
        }
        return null; // force the unmount
    }
}
